<template>
    <div>
        <div>
            <div class="flex flex-row text-teal hover:text-teal-dark font-base text-sm mb-4">
                <div @click="goBack" class="flex flex-row cursor-pointer">
                    <span class="material-icons">chevron_left</span>
                    <span>Back</span>
                </div>
            </div>
        </div>
        <div class="flex flex-row justify-around">
            <form @submit.prevent="saved" @keydown="form.errors.clear($event.target.name)"
                  class="flex flex-row justify-center w-full">
                <div class="pb-4 pt-2 rounded shadow-md w-full bg-white">
                    <div v-if="isLoading" class="scanoverlay">
                        <i class="fa fa-spinner fa-spin loading-spinner">
                        </i>
                        Uploading and scanning image
                    </div>

                    <div class="text-grey-darkest text-base text mb-8 border-b-2 border-followup-nav px-4 overflow-hidden">
                        <div class="w-50 float-left">New Contact</div>
                        <div class="w-50 float-right text-right md:hidden">
                            <input
                                type="file"
                                accept="image/*"
                                capture="camera"
                                @change="onFileChange"
                                ref="fileInput"
                                style="display: none;"
                                id="fileInput"
                            />
                            <i class="fa fa-qrcode" style="font-size: 31px;" aria-hidden="true" @click="clearFileSelection();openCamera()"></i>
                        </div>
                    </div>

                    <div class="flex flex-row justify-content-between px-4">
                        <div class="mb-3 w-full flex flex-no-wrap mr-6">
                            <div class="w-4/5">
                                <label class="text-grey-darkest text-sm" for="name" :class="{'text-red': form.errors.has('name')}">Name</label>
                                <input v-model="form.name" id="name" name="name" maxlength="64"
                                    class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-3 text-grey-darkest w-full focus:outline-none"
                                    :class="{'border-red': form.errors.has('name')}">
                                <div class="text-red" v-if="form.errors.has('name')">{{ form.errors.get('name') }}</div>
                            </div>
                            <div class="w-1/5 flex justify-center items-center">
                                <div class="text-center cursor-pointer table mb-0"
                                    @click.prevent.stop="openCompanyContactModal()">
                                    <i class="fa fa-user fa-2x"></i>
                                    <i class="fa fa-plus-circle text-teal" style="margin-left: -22px"></i>
                                </div>
                            </div>
                        </div>
                        <div class="mb-3 w-full">
                            <label class="text-grey-darkest text-sm" for="cell" :class="{'text-red': form.errors.has('cell')}">Cell</label>
                            <input v-model="form.cell" id="cell" name="cell" maxlength="64"
                                   v-mask="['(###) ###-####', '(###) ###-#### ext. #####']"
                                   class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-3 text-grey-darkest w-full focus:outline-none"
                                   :class="{'border-red': form.errors.has('cell')}">
                            <div class="text-red" v-if="form.errors.has('cell')">{{ form.errors.get('cell') }}</div>
                        </div>
                    </div>

                    <div class="flex flex-row justify-content-between px-4">
                        <div class="mb-3 w-full mr-6">
                            <label class="text-grey-darkest text-sm" for="email" :class="{'text-red': form.errors.has('email')}">Email</label>
                            <input v-model="form.email" id="email" name="email" maxlength="64"
                                   class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-3 text-grey-darkest w-full focus:outline-none"
                                   :class="{'border-red': form.errors.has('email')}">
                            <div class="text-red" v-if="form.errors.has('email')">{{ form.errors.get('email') }}</div>
                        </div>
                        <div class="mb-3 w-full">
                            <label class="text-grey-darkest text-sm" for="title" :class="{'text-red': form.errors.has('title')}">Title</label>
                            <input v-model="form.title" id="title" title="title" maxlength="64"
                                   class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-3 text-grey-darkest w-full focus:outline-none"
                                   :class="{'border-red': form.errors.has('title')}">
                            <div class="text-red" v-if="form.errors.has('title')">{{ form.errors.get('title') }}</div>
                        </div>
                    </div>

                    <div class="flex flex-row justify-content-between px-4">
                        <div class="mb-3 w-full mr-6">
                            <label class="text-grey-darkest text-sm" :class="{'text-red': form.errors.has('date')}">Follow Up</label>
                            <div class="flex">
                                <datetime type="datetime" id="date" name="date" v-model="form.date" use12-hour
                                          class="w-full"
                                          :format="{ year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: '2-digit' }"
                                          input-class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-3 text-grey-darkest w-full focus:outline-none"
                                          @input="form.errors.clear('date')">
                                </datetime>
                                <button v-if="form.date" @click.prevent.stop="removeDate"
                                        class="material-icons text-grey-darkest text-xl focus:outline-none">clear
                                </button>
                            </div>
                            <div class="text-red" v-if="form.errors.has('date')">{{ form.errors.get('date') }}</div>
                        </div>
                        <div class="mb-3 w-full">
                            <label class="text-grey-darkest text-sm" :class="{'text-red': form.errors.has('user')}">User</label>
                            <multiselect class="cursor-pointer" :options="users" v-model="form.user" :show-labels="false" @input="form.errors.clear('user')"
                                         track-by="id" label="name" value="id"></multiselect>
                            <div class="text-red" v-if="form.errors.has('user')">{{ form.errors.get('user') }}</div>
                        </div>
                    </div>

                     <div class="flex flex-row justify-content-between px-4">
                         <div class="mb-3 mr-6 lg:w-1/2">
                            <label class="text-grey-darkest text-sm"
                                   :class="{'text-red': form.errors.has('contact_types_id')}">Contact Type</label>
                            <multiselect
                                class="cursor-pointer"
                                :options="contactTypes"
                                v-model="selectedType"
                                :show-labels="false"
                                @input="form.errors.clear('contact_types_id')"
                                track-by="id"
                                label="code"
                                value="id">
                            </multiselect>
                            <div class="text-red" v-if="form.errors.has('contact_types_id')">The contact type field is required.</div>
                        </div>
                    </div>

                    <div class="flex flex-row justify-end mt-4 pr-4">
                        <a :href="`/company/${company.id}`" class="flex items-center mr-4 text-teal hover:text-teal-dark">
                            Cancel
                        </a>
                        <button class="py-2 px-4 rounded-full flex flex-row items-center justify-center focus:outline-none hover:bg-teal-dark"
                                :class="{'bg-teal-lighter cursor-not-allowed' : form.errors.any(), 'bg-teal' : !form.errors.any()}"
                                :disabled="form.errors.any()">
                            <span class="text-white font-bold">Create</span>
                        </button>
                    </div>
                </div>
            </form>
            <div class="modal" id="exist_contact" tabindex="-1">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content" style="border-radius: 12px; overflow: hidden;width: 400px;">
                        <div class="modal-header">
                            <div class="row" style="height: 200px;">
                                <div class="col-md-12" style="text-align: center; font-size:25px; margin-top:15px;font-weight: bold;">This contact already exists</div>
                                <div class="col-md-12" style="text-align: center;" data-dismiss="modal">
                                    <button type="button" @click="pageReload" class="btn btn-primary" style="padding: 15px 40px;box-shadow: #989797 0px 0px 5px 2px;margin-right: 12px;"
                                    > Cancel</button>
                                    <button type="button" @click="contactDetails()" class="btn btn-default" style="padding: 15px 40px;box-shadow: #989797 0px 0px 5px 2px; background:rgb(152 151 151);color: white;"
                                    >Add</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <company-contact-modal ref="CompanyContactModal" :masks="this.masks" :symbols="this.symbols" :exchange="this.exchange" @selected="parseContact"></company-contact-modal>
            <project-contact-modal ref="EmailContactModal" :masks="this.masks" :symbols="this.symbols" :exchange="this.exchange" @selected="parseContact"></project-contact-modal>
        </div>
    </div>
</template>

<script>

    import Form from "../../utils/form";
    import Multiselect from 'vue-multiselect';
    import Swal from "sweetalert2";

    export default {
        name:'contact-create',
        props: ['company','masks',
            'symbols','exchange'],
        components: {Multiselect},

        mounted() {
            Bus.$on('openEmailContactModalParent', data => {
                console.log('data',data);
                this.$refs.CompanyContactModal.close();
                this.$refs.EmailContactModal.open();
            });
            Bus.$on('openCompanyContactModal', data => {
                this.$refs.EmailContactModal.close();
                this.$refs.CompanyContactModal.open();

            });
            this.getUsers();
            this.getContactTypes();
        },

        data() {
            return {
                form: new Form({
                    name: '',
                    cell: '',
                    email: '',
                    title: '',
                    date: null,
                    completed: null,
                    user: null,
                    contact_types_id: null,
                    contact_id: null,
                    company_id:null
                }),
                contactTypes: [],
                selectedType: null,
                users: [],
                imageData:null,
                isLoading: false,
            }
        },

        watch: {
            selectedType(val){
                this.form.contact_types_id = val.id;
            }
        },

        methods: {
            saved() {
                let self = this;
                this.form.post(route('api.company.contact.check', {company: this.company.id, fromWhere: 'project'}))
                    .then((response) => {
                        if (response.status == 'error') {
                            Swal.fire({
                                title: 'Company Contact Already Exists',
                                text: "Do you want to create a duplicate contact",
                                type: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#01B1AF',
                                confirmButtonText: 'Continue creating!'
                            }).then((result) => {
                                if (result.value) {
                                    this.savedAfterCheck();
                                }else{
                                    return false;
                                }
                            });
                        }else{
                            this.savedAfterCheck();
                        }
                    });
            },

            goBack() {
                window.location = "/company/" + this.company.id;
            },

            removeDate() {
                this.form.date = null;
                this.form.completed = null;
                this.form.user = null;
            },

            getUsers() {
                let self = this;
                axios.get(route('api.contact.users')).then(({data}) => {
                    self.users = data;
                });
            },


            openCompanyContactModal() {
                this.$refs.EmailContactModal.close();
                this.$refs.CompanyContactModal.open();
            },

            parseContact(contact) {
                this.form.name  = contact.name;
                if (contact.phone){
                    this.form.cell = contact.phone;
                }else {
                    this.form.cell = contact.cell;
                }
                this.form.email = contact.email;
            },
            pageReload(){
                window.location.reload();
            },
            contactDetails(){
                window.location = "/company/" + this.form.company_id +"/contact/"+this.form.contact_id+"/edit";
            },

            getContactTypes() {
                let self = this;
                axios.get(route('api.settings.codes.contact-type.index')).then(({data}) => {
                    self.contactTypes = data.filter(x => !x.is_residential)
                    self.contactTypes.push({id:null,code:""})
                });
            },
            savedAfterCheck(){
                this.form.post(route('api.contact.store', {company: this.company.id})).then((response) => {
                    if (response.exists){
                        this.form.contact_id = response.contact_id;
                        this.form.company_id = response.company_id;
                        $('#exist_contact').modal('show');
                    }else {
                        this.getToast().fire({
                            type: 'success',
                            title: 'Your contact has been created.',
                        });
                        window.location = "/company/" + this.company.id;
                    }
                });
            },
            openCamera() {
                // Trigger the hidden file input
                this.$refs.fileInput.click();
            },
            onFileChange(event) {
                const file = event.target.files[0];
                if (file) {
                    const formData = new FormData();
                    formData.append('file', file);

                    try {
                        this.isLoading = true;
                        axios.post(route('api.company.add-contact.extract-visiting-card-details'), formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        }).then((res) => {
                            this.isLoading = false;
                            if(res.data.status == 'error'){
                                this.getToast(4000).fire({
                                    type: 'error',
                                    title: res.data.message
                                });
                                return false;
                            }else{
                                let data = res.data.data;
                                if(res.data.company){
                                    this.form.existing_company = res.data.company;
                                    this.remove_validations();
                                    this.disableToggle();
                                }else if(data.company){
                                    this.form.new_company = data.company;
                                    this.remove_validations();
                                    this.disableExistingCompany();
                                }
                                if(data.name){
                                    this.form.name = data.name;
                                }
                                if(data.email){
                                    this.form.email = data.email;
                                }
                                if(data.title){
                                    this.form.title = data.title;
                                }
                                if(data.phone){
                                    this.form.cell = data.phone;
                                }
                                if(data.address && !data.street){
                                    this.form.address = data.address;
                                }else if(data.street){
                                    this.form.address = data.street;
                                }
                                if(data.city){
                                    this.form.city = data.city;
                                }
                                if(data.state){
                                    this.form.state = data.state;
                                }
                                if(data.postalCode){
                                    this.form.zip = data.postalCode;
                                }
                            }
                        });
                    } catch (error) {
                        this.isLoading = false;
                        console.error('Error uploading file:', error);
                        this.getToast(4000).fire({
                            type: 'error',
                            title: 'Something went wrong. Unable to scan the image. Please scan again'
                        });
                        return false;
                    }
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        this.imageData = e.target.result;
                    };
                    reader.readAsDataURL(file);
                }
            },
            clearFileSelection(){
                const fileInput = document.getElementById('fileInput');
                fileInput.value = '';
            },
        }
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.scanoverlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
}

.loading-spinner {
    font-size: 2rem;
    color: #333;
}

.relative {
    position: relative;
}
</style>
